import {ChangeEvent} from 'react';

export const parseInputValue = (event: ChangeEvent<HTMLInputElement>) => {
  const {target} = event;
  return target.value;
};
